import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { createGitRepo } from '@/services/git/api';
import type { CreateGitRepoInput, GitRepo } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useCreateGitRepo(): UseMutationResult<GitRepo, Error, CreateGitRepoInput> {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useMutation({
    mutationFn: (input: CreateGitRepoInput) => createGitRepo(orgId!, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gitRepos', orgId] });
    },
  });
}
